import { render, staticRenderFns } from "./ClinicDentists.vue?vue&type=template&id=5c1d3792&"
import script from "./ClinicDentists.vue?vue&type=script&lang=js&"
export * from "./ClinicDentists.vue?vue&type=script&lang=js&"
import style0 from "./ClinicDentists.vue?vue&type=style&index=0&id=5c1d3792&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports